module.exports = __webpack_public_path__ + "6cfb608498e1d4ebe20a6b886ec91e06.pdf";